
import React, { Component } from 'react'
import FileUploadButton from '../../FileUploadButton/FileUploadButton';

export default class UploadSection extends Component {

    render() {
        const { onChangeFileFunc, onChangeCategoryFunc,categories ,orderFileUpload} = this.props;
        
        return(
            <div class="col-md-12 my-3 style-td-border">
                <table class="table">
                    <thead class="border-bottom-0">
                        <tr class="border-bottom-0">
                            <th class="border-bottom-0 text-left" width="12.5%">
                                <FileUploadButton
                                    onChange={(e) => onChangeFileFunc(e)}
                                />
                            </th>
                            {categories.map((data,i) => (
                            <th key={i} class="border-bottom-0 text-left" width="12.5%">{data}</th>    
                            )
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {orderFileUpload.map((filedata,index) =>
                            (
                            <tr>
                            <td class="border-top-0 text-left">
                                {filedata.path.split('/').slice(-1).pop()}
                            </td>
                            {categories.map((data,i) => (
                                <td key={i} class="border-top-0 text-left">
                                    <p className="radio-inline nopadding">
                                        <input name={'group'+index} type="radio" className="filled-in hide-all" 
                                        id={filedata.path+i} value={data+index} checked={filedata.fileType == data+index} 
                                        onChange={(e) => onChangeCategoryFunc(e.target.value,index)} />
                                        <label
                                        for={filedata.path+i}>
                                        </label>
                                    </p>
                                </td>
                            )
                            )}
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/CreateIBComponents/uploadSectionOrder/UploadSection.js